
import QTable from 'quasar/src/components/table/QTable.js';
import { defineComponent, computed, PropType } from 'vue'

export default defineComponent({
  name: 'VehicleReportPrintRestriction',

  props: {
    rows: {
      type: Array,
      required: true,
    },
  },

  setup(props) {
    const columns: QTable['columns'] = [
      {
        align: 'left',
        name: 'text',
        label: 'Fordon',
        field: 'text',
        sortable: false,
        style: 'width: 100px; min-width: 100px',
      },
      {
        align: 'left',
        name: 'restriction',
        label: 'Restriktion',
        field: 'restriction',
        style: 'width: 445px; min-width: 445px;',
        sortable: false,
      },
    ]

    const data = computed(() => {
      return props.rows
    })

    return {
      columns,
      data,
    }
  },
})
